/*eslint-disable*/
import React, { useState } from "react";
import { Link } from "react-router-dom";
import UserDropdown from "components/Dropdowns/UserDropdown.js";
import ifLogoWhite from "../../assets/img/if-logo.png";
import OpenDocument from "helpers/openDocument";

function Sidebar({
  loggedUser,
  selectedMenu,
  userPermissions,
  SetSelectedMenu,
  systemSettings,
}) {
  const [collapseShow, setCollapseShow] = useState("hidden");
  const isSuperAdmin = loggedUser?.role === "superAdmin";
  const isAdmin = loggedUser?.role === "admin";
  const mainBackground = systemSettings?.backgroundSideBar;

  return (
    <>
      <nav
        style={{ backgroundColor: mainBackground }}
        className="min-[1324px]:left-0 min-[1324px]:block min-[1324px]:fixed min-[1324px]:top-0 min-[1324px]:bottom-0 min-[1324px]:overflow-y-auto min-[1324px]:flex-row min-[1324px]:flex-nowrap min-[1324px]:overflow-hidden shadow-xl bg-qt flex flex-wrap items-center justify-between relative min-[1324px]:w-[264px] z-10 py-4 px-4"
      >
        <div className="min-[1324px]:flex-col min-[1324px]:items-stretch min-[1324px]:min-h-full min-[1324px]:flex-nowrap px-0 flex flex-wrap items-center justify-between w-full mx-auto">
          {/* Toggler */}
          <button
            className="cursor-pointer text-white opacity-75 min-[1324px]:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
            type="button"
            onClick={() => setCollapseShow("bg-qt m-2 py-3 px-6")}
          >
            <i className="fas fa-bars"></i>
          </button>
          {/* Brand */}
          <div className="text-center flex gap-2 my-4 border-1">
            {/* <img
              src={ifLogoWhite}
              alt="IF Logo"
              className="h-12 w-auto mr-1 inline-block"
            /> */}
            <OpenDocument
              mimeType={"image"}
              document={systemSettings?.logoImage}
              downloadable={false}
              type={"logo"}
              imgClassName="h-12 w-auto mr-1 inline-block"
            />
            <Link
              className="min-[1324px]:block text-left min-[1324px]:pb-2 text-white opacity-90 mr-0 inline-block whitespace-nowrap text-2xl uppercase font-bold p-4 px-0"
              to="/"
            >
              {systemSettings?.systemNameAbr ?? "RMS"}
            </Link>
          </div>

          {/* User */}
          <ul className="min-[1324px]:hidden items-center flex flex-wrap list-none">
            {/*<li className="inline-block relative">*/}
            {/*  <NotificationDropdown />*/}
            {/*</li>*/}
            <li className="inline-block relative">
              <UserDropdown loggedUser={loggedUser} />
            </li>
          </ul>
          {/* Collapse */}
          <div
            className={
              "min-[1324px]:flex min-[1324px]:flex-col min-[1324px]:items-stretch min-[1324px]:opacity-100 min-[1324px]:relative min-[1324px]:mt-4 min-[1324px]:shadow-none shadow absolute top-0 left-0 right-0 z-40 overflow-y-auto overflow-x-hidden h-auto items-center flex-1 rounded " +
              collapseShow
            }
          >
            {/* Collapse header */}
            <div className="min-[1324px]:min-w-full min-[1324px]:hidden block pb-4 mb-4 border-b border-solid border-white font-medium">
              <div className="flex flex-wrap">
                <div className="w-6/12">
                  <Link
                    className="min-[1324px]:block text-left min-[1324px]:pb-2 text-white font-medium mr-0 inline-block whitespace-nowrap text-sm uppercase font-bold p-4 px-0"
                    to="/"
                  >
                    {systemSettings?.systemNameFull ??
                      "QT Resource Management System"}
                  </Link>
                </div>
                <div className="w-6/12 flex justify-end">
                  <button
                    type="button"
                    className="cursor-pointer text-black opacity-50 min-[1324px]:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
                    onClick={() => setCollapseShow("hidden")}
                  >
                    <i className="fas fa-times"></i>
                  </button>
                </div>
              </div>
            </div>

            {/* Divider */}
            {/*<hr className="my-4 md:min-w-full" />*/}
            <span className="text-white text-xs my-2">MENU</span>
            {/* Navigation */}

            <ul className="min-[1324px]:flex-col min-[1324px]:min-w-full flex flex-col list-none">
              {userPermissions?.map((item) => (
                <li
                  className="items-center"
                  onClick={() => {
                    SetSelectedMenu({
                      menu: item.name,
                      title: item.name,
                    });
                  }}
                >
                  <Link
                    className={
                      "text-xs uppercase py-2 my-1 block " +
                      (selectedMenu?.menu === item.name
                        ? "text-white hover:text-white bg-secondaryAlt px-4 rounded-lg"
                        : "text-white font-medium hover:text-secondaryAlt px-4")
                    }
                    to={item.link}
                  >
                    <i
                      className={
                        `${item.icon} mr-2 text-sm ` +
                        (selectedMenu?.menu === item.name
                          ? "opacity-75"
                          : "text-white")
                      }
                    ></i>{" "}
                    {item.name}
                  </Link>
                </li>
              ))}
              {isAdmin ? (
                <li
                  className="items-center"
                  onClick={() => {
                    SetSelectedMenu({
                      menu: "Settings",
                      title: "Settings",
                    });
                  }}
                >
                  <Link
                    className={
                      "text-xs uppercase py-2 my-1 block " +
                      (selectedMenu?.menu === "Settings"
                        ? "text-white hover:text-white bg-secondaryAlt px-4 rounded-lg"
                        : "text-white font-medium hover:text-secondaryAlt px-4")
                    }
                    to={"/admin/seetings"}
                  >
                    <i
                      className={
                        `fas fa-cog mr-2 text-sm ` +
                        (selectedMenu?.menu === "Settings"
                          ? "opacity-75"
                          : "text-white")
                      }
                    ></i>{" "}
                    {"Settings"}
                  </Link>
                </li>
              ) : null}

              {isSuperAdmin ? (
                <li
                  className="items-center"
                  onClick={() => {
                    SetSelectedMenu({
                      menu: "System Settings",
                      title: "System Settings",
                    });
                  }}
                >
                  <Link
                    className={
                      "text-xs uppercase py-2 my-1 block " +
                      (selectedMenu?.menu === "System Settings"
                        ? "text-white hover:text-white bg-secondaryAlt px-4 rounded-lg"
                        : "text-white font-medium hover:text-secondaryAlt px-4")
                    }
                    to={"/admin/system/settings"}
                  >
                    <i
                      className={
                        `fas fa-user mr-2 text-sm ` +
                        (selectedMenu?.menu === "System Settings"
                          ? "opacity-75"
                          : "text-white")
                      }
                    ></i>{" "}
                    {"System Admin"}
                  </Link>
                </li>
              ) : null}
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}
export default Sidebar;
